import {
  Button,
  Card,
  Form,
  Input,
  message,
  Radio,
  App,
  Spin,
  Upload,
  InputNumber,
  Progress,
} from "antd";
import Uppy from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";
import { Dashboard } from "@uppy/react";
import { useEffect, useState, useMemo } from "react";
import { APP_SETTING, GET_AWS_SIGN_UPLOAD_Magazine } from "../../apis/apis";
import { useNavigate } from "react-router-dom";
import {
  Loading3QuartersOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import CulsightPageLoader from "../../components/CulsightPageLoader";

export default function AppSetting() {
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const [banner, set_banner] = useState("");
  const [button_text, set_button_text] = useState("");
  const [banner_api, set_banner_api] = useState("");
  const [heading, set_heading] = useState("");
  const [text, set_text] = useState("");
  const [web_link, set_web_link] = useState("");
  const [show_leaderboard_on_lms, set_show_leaderboard_on_lms] = useState(0);
  const [number_of_upcoming_event, set_number_of_upcoming_event] =
    useState(null);
  const [number_of_news, set_number_of_news] = useState(null);
  const [errors, set_errors] = useState("");
  const [bannerError, setbannerError] = useState("");
  // Cover Image
  const [cover_image, set_cover_image] = useState("");
  const [cover_image_api, set_cover_image_api] = useState("");
  const [coverImageError, setCoverImageError] = useState("");
  const [magazine_title, set_magazine_title] = useState("");
  const [magazine_description, set_magazine_description] = useState("");

  // PDF
  const [pdfUploading, setPdfUploading] = useState(false);
  const [pdfProgress, setPdfProgress] = useState(0);
  const [pdfUploadingMessage, setPdfUploadingMessage] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [uploadCompleted, setUploadCompleted] = useState(false);
  const [JWT_ACCESS_TOKEN_MINUTES, set_JWT_ACCESS_TOKEN_MINUTES] = useState("");
  const [JWT_REFRESH_TOKEN_DAYS, set_JWT_REFRESH_TOKEN_DAYS] = useState("");
  const [maxDownloadLimit, setMaxDownloadLimit] = useState("");

  const uppy = useMemo(() => {
    const uppyInstance = new Uppy({
      autoProceed: true,
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ["application/pdf"],
        maxFileSize: 20 * 1024 * 1024,
      },
    });

    uppyInstance.use(AwsS3, {
      async getUploadParameters(file) {
        setPdfUploading(true);
        setPdfProgress(0);
        setPdfUploadingMessage("Preparing upload...");

        const formData = new FormData();

        formData.append("filename", file.name);
        formData.append("type", file.type);

        const response = await GET_AWS_SIGN_UPLOAD_Magazine(formData);

        if (!response?.data?.status) {
          throw new Error("Unable to generate signed url");
        }

        const uploadUrl = response.data.uploadUrl;

        const fileKey = response.data.fileKey;
        setPdfUrl(fileKey);

        setPdfUrl(fileKey);

        return {
          method: "POST",
          url: uploadUrl,
          headers: {
            "Content-Type": file.type,
          },
        };
      },
    });

    uppyInstance.on("upload-progress", (file, progress) => {
      const percent = Math.round(
        (progress.bytesUploaded / progress.bytesTotal) * 100,
      );

      setPdfProgress(percent);
      setPdfUploadingMessage("Uploading PDF...");
    });

    uppyInstance.on("upload-success", () => {
      setPdfUploading(false);

      setPdfProgress(100);

      setUploadCompleted(true);

      notification.success({
        message: "PDF Uploaded Successfully",
      });
    });

    uppyInstance.on("upload-error", () => {
      setPdfUploading(false);

      setPdfProgress(0);

      notification.error({
        message: "Upload Failed",
      });
    });

    return uppyInstance;
  }, []);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleChange = async (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    set_banner_api(info.file);
    if (info.file.status === "done") {
      console.log(info.file.originFileObj);
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        set_banner(url);
      });
    } else if (info.file.status === "error") {
      setLoading(false);
      message.error("Upload failed. Please try again.");
    }
  };
  const handleCoverChange = async (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }

    set_cover_image_api(info.file);

    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        set_cover_image(url);
      });
    } else if (info.file.status === "error") {
      setLoading(false);
      message.error("Upload failed. Please try again.");
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? (
        <Loading3QuartersOutlined />
      ) : (
        <PlusOutlined style={{ color: "#fff" }} />
      )}
      <div style={{ marginTop: 8, color: "#fff" }}>Upload</div>
    </button>
  );
  const coverUploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? (
        <Loading3QuartersOutlined />
      ) : (
        <PlusOutlined style={{ color: "#fff" }} />
      )}
      <div style={{ marginTop: 8, color: "#fff" }}>Upload</div>
    </button>
  );

  const pdfProps = {
    accept: ".pdf",
    maxCount: 1,
    beforeUpload(file) {
      if (file.type !== "application/pdf") {
        message.error("Only PDF files are allowed.");
        return Upload.LIST_IGNORE;
      }

      const isLt20MB = file.size / 1024 / 1024 < 20;

      if (!isLt20MB) {
        message.error("PDF must be smaller than 20MB.");
        return Upload.LIST_IGNORE;
      }

      setPdfUploading(true);
      setPdfProgress(100);
      //setPdfUrl(fileKey);
      setPdfUploading(false);

      return false;
    },
  };

  //ADD API
  const onFinish = async () => {
    setLoading(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("banner", banner_api);
    FORM_DATA.append("magazine_cover", cover_image_api);
    FORM_DATA.append("magazine_pdfx", pdfUrl);
    FORM_DATA.append("heading", heading);
    FORM_DATA.append("text", text);
    FORM_DATA.append("button_text", button_text);
    FORM_DATA.append("web_link", web_link);
    FORM_DATA.append("title", magazine_title);
    FORM_DATA.append("description", magazine_description);
    FORM_DATA.append("max_download_limit", maxDownloadLimit);

    if (
      JWT_ACCESS_TOKEN_MINUTES !== null &&
      JWT_ACCESS_TOKEN_MINUTES !== undefined
    ) {
      FORM_DATA.append("jwt_access_token_minutes", JWT_ACCESS_TOKEN_MINUTES);
    }
    if (
      JWT_REFRESH_TOKEN_DAYS !== null &&
      JWT_REFRESH_TOKEN_DAYS !== undefined
    ) {
      FORM_DATA.append("jwt_refresh_token_days", JWT_REFRESH_TOKEN_DAYS);
    }
    if (
      number_of_upcoming_event !== null &&
      number_of_upcoming_event !== undefined
    ) {
      FORM_DATA.append("number_of_upcoming_event", number_of_upcoming_event);
    }

    if (number_of_news !== null && number_of_news !== undefined) {
      FORM_DATA.append("number_of_news", number_of_news);
    }

    FORM_DATA.append(
      "show_leaderboard_on_lms",
      show_leaderboard_on_lms.toString(),
    );
    try {
      const response = await APP_SETTING(FORM_DATA);
      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });

        setLoading(false);
        navigate("/app-setting-tab");
      } else {
        setLoading(false);
        set_errors(response?.data?.errors);
      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error"),
      );
    }
  };

  useEffect(() => {
    const view_api = async () => {
      setLoading(true);
      const FORM_DATA = new FormData();
      try {
        const response = await APP_SETTING(FORM_DATA);
        if (response?.data?.status) {
          const response_data = response?.data?.data;
          set_heading(response_data?.heading);
          set_button_text(response_data?.meta?.button_text);
          set_magazine_title(response_data?.meta?.magazine_title || "");
          setMaxDownloadLimit(response?.data?.data?.max_download_limit || "");
          set_magazine_description(
            response_data?.meta?.magazine_description || "",
          ); 
          form.setFieldsValue({
            button_text: response_data?.meta?.button_text,
            magazine_title: response_data?.meta?.magazine_title,
            magazine_description: response_data?.meta?.magazine_description,
          });
          set_text(response_data?.text);
          set_show_leaderboard_on_lms(
            Number(response_data?.show_leaderboard_on_lms),
          );
          set_web_link(response_data?.web_link);
          set_number_of_upcoming_event(response_data?.number_of_upcoming_event);
          set_number_of_news(response_data?.number_of_news);
          set_JWT_ACCESS_TOKEN_MINUTES(
            response_data?.meta?.jwt_access_token_minutes,
          );
          set_JWT_REFRESH_TOKEN_DAYS(
            response_data?.meta?.jwt_refresh_token_days,
          );

          if (response_data?.banner) {
            set_banner(response_data.banner);
          } else {
            set_banner("");
          }
          setLoading(false);
        } else {
          setLoading(false);
          set_errors(response?.data?.errors);
        }
      } catch (error) {
        message.error(
          "Server Error: " +
            (error?.response?.data?.message || "Unknown error"),
        );
      }
    };
    view_api();
  }, []);

  return (
    <div>
     
   
        {loading ? (
          <>
            <CulsightPageLoader />
          </>
        ) : (
          <>
            <Form
              layout="vertical"
              form={form}
              autoComplete="off"
              validateTrigger="onSubmit"
              onFinish={onFinish}
            >
              <Form.Item label="Upload Banner here">
                <Upload
                  name="avatar"
                  style={{ width: "250px", minHeight: "200px" }}
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  beforeUpload={(file) => {
                    console.log(file);
                    const isJpgOrPng =
                      file.type === "image/jpeg" ||
                      file.type === "image/png" ||
                      file.type === "image/jpg";
                    // const isLt2M = file.size <= 2 * 1024 * 1024;
                    const isLt512KB = file.size <= 512 * 1024;

                    if (!isJpgOrPng) {
                      set_banner_api("");
                      set_banner("");
                      setbannerError("Only JPG/PNG files are allowed.");
                      return false;
                    }

                    if (!isLt512KB) {
                      set_banner_api("");
                      set_banner("");
                      setbannerError(
                        "banner must be smaller than or equal to 512KB.",
                      );
                      return false;
                    }
                    const img = new Image();
                    img.src = URL.createObjectURL(file);

                    img.onload = () => {
                      const { width, height } = img;
                      // Example: Minimum 300x300 pixels
                      if (width === 490 && height === 320) {
                        setbannerError(""); // Clear errors if valid

                        // Set preview and file for API
                        getBase64(file, (url) => set_banner(url));
                        set_banner_api(file);
                      } else {
                        set_banner_api("");
                        set_banner("");
                        setbannerError(
                          "Image must be at least 490x320 pixels.",
                        );
                      }
                    };
                    return false;
                  }}
                  onChange={handleChange}
                >
                  {banner ? (
                    <img
                      src={banner}
                      alt="avatar"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>

                {/* Error message under the uploader */}
                {bannerError && (
                  <span
                    style={{ color: "red", display: "block", marginTop: 8 }}
                  >
                    {bannerError}
                  </span>
                )}
                {/* Server-side validation error */}
                {errors?.banner && (
                  <span
                    style={{ color: "red", display: "block", marginTop: 8 }}
                  >
                    {errors?.banner}
                  </span>
                )}
                <p style={{ color: "#65e7c4", marginTop: "10px" }}>
                  Note - banner must be smaller than or equal to 512KB and must
                  be at least 490x320 pixels.
                </p>
              </Form.Item>

              <Form.Item label="Banner Heading">
                <Input
                  value={heading}
                  onChange={(e) => set_heading(e.target.value)}
                />
                {errors?.heading && (
                  <span style={{ color: "red" }}>{errors.heading}</span>
                )}
              </Form.Item>

              <Form.Item label="Banner Para">
                <Input
                  value={text}
                  onChange={(e) => set_text(e.target.value)}
                />
                {errors?.text && (
                  <span style={{ color: "red" }}>{errors.text}</span>
                )}
              </Form.Item>

              <Form.Item label="Button Text">
                <Input
                  value={button_text}
                  onChange={(e) => set_button_text(e.target.value)}
                />
                {errors?.button_text && (
                  <span style={{ color: "red" }}>{errors.button_text}</span>
                )}
              </Form.Item>

              <Form.Item label="Web Link">
                <Input
                  value={web_link}
                  onChange={(e) => set_web_link(e.target.value)}
                />
                {errors?.web_link && (
                  <span style={{ color: "red" }}>{errors.web_link}</span>
                )}
              </Form.Item>

              <Form.Item label="Number upcoming event">
                <InputNumber
                  style={{ width: "100%" }}
                  value={number_of_upcoming_event}
                  onChange={(value) => set_number_of_upcoming_event(value)}
                  placeholder="Enter here"
                />
                {errors?.number_of_upcoming_event && (
                  <span style={{ color: "red" }}>
                    {errors.number_of_upcoming_event}
                  </span>
                )}
              </Form.Item>

              <Form.Item label="Number of News">
                <InputNumber
                  style={{ width: "100%" }}
                  value={number_of_news}
                  onChange={(value) => set_number_of_news(value)}
                  placeholder="Enter here"
                />
                {errors?.number_of_news && (
                  <span style={{ color: "red" }}>{errors.number_of_news}</span>
                )}
              </Form.Item>

              <Form.Item label="Access Token Expiry Time (in minutes)">
                <InputNumber
                  style={{ width: "100%" }}
                  value={JWT_ACCESS_TOKEN_MINUTES}
                  onChange={(value) => set_JWT_ACCESS_TOKEN_MINUTES(value)}
                  placeholder="Enter here"
                />
                {errors?.JWT_ACCESS_TOKEN_MINUTES && (
                  <span style={{ color: "red" }}>
                    {errors.JWT_ACCESS_TOKEN_MINUTES}
                  </span>
                )}
              </Form.Item>

              <Form.Item label="Refresh Token Expiry Time (in days)">
                <InputNumber
                  style={{ width: "100%" }}
                  value={JWT_REFRESH_TOKEN_DAYS}
                  onChange={(value) => set_JWT_REFRESH_TOKEN_DAYS(value)}
                  placeholder="Enter here"
                />
                {errors?.JWT_REFRESH_TOKEN_DAYS && (
                  <span style={{ color: "red" }}>
                    {errors.JWT_REFRESH_TOKEN_DAYS}
                  </span>
                )}
              </Form.Item>

              <Form.Item label="Show Leaderboard On LMS">
                <Radio.Group
                  value={show_leaderboard_on_lms}
                  onChange={(e) => set_show_leaderboard_on_lms(e.target.value)}
                >
                  <Radio value={1}>Yes</Radio>
                  <Radio value={0}> No </Radio>
                </Radio.Group>
                {errors?.show_leaderboard_on_lms ? (
                  <>
                    <span style={{ color: "red" }}>
                      {errors?.show_leaderboard_on_lms}
                    </span>
                  </>
                ) : (
                  <></>
                )}

             
              </Form.Item>

              <Form.Item>
                {loading ? (
                  <>
                    <Button
                      type="primary"
                      style={{ float: "right" }}
                      htmlType="submit"
                    >
                      Save
                      <Spin indicator={<LoadingOutlined spin />} size="small" />
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      type="primary"
                      htmlType="submit"
                     // disabled={!uploadCompleted}
                    >
                      Save
                    </Button>
                  </>
                )}
              </Form.Item>
            </Form>
          </>
        )}
    
    </div>
  );
}
